import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import type { Tables } from '@/integrations/supabase/types';

export type Policy = Tables<'policies'> & {
  owner_profile?: {
    full_name: string;
  } | null;
};

export function usePolicies() {
  return useQuery({
    queryKey: ['policies'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('policies')
        .select(`
          *,
          owner_profile:profiles!policies_policy_owner_fkey(full_name)
        `)
        .is('deleted_at', null)
        .order('name', { ascending: true });

      if (error) throw error;
      return data as Policy[];
    },
  });
}

export function usePolicyCategories(policies: Policy[] | undefined) {
  if (!policies) return [];
  const categories = [...new Set(policies.map((p) => p.category))];
  return categories.sort();
}
